<template>
  <div class="container">
    <h3 class="title">{{ $t('currency.customButton') }}</h3>

    <div class="fabric-library-content">
      <div class="filters f--c">
        <el-cascader
          v-model="categoryIds"
          :options="options"
          :props="{ multiple: true }"
          size="mini"
          @change="e => changeCascader(e)"
          collapse-tags
          clearable
          style="200px">
        </el-cascader>
        <el-input v-model.trim="filters.searchContent" clearable size="mini" placeholder="search" style="width: 300px;" @change="handleSearchInput">
          <el-button slot="append" icon="el-icon-search" @click="handleSearchInput"></el-button>
        </el-input>
      </div>
      <div class="fabric-library-box">
        <div class="fabric-library-list f">
          <div v-for="item in list" :key="item.id" class="fabric-item">
            <div class="img pointer" @click="jump(item.imageUrl)">
              <oss-img :src="item.imageUrl" :width="300" />
            </div>
            <div class="name ellipsis" :title="item.buttonsCode"><span class="category">Style#:</span> {{item.buttonsCode}}</div>
            <div class="name ellipsis" :title="item.fullCategoryName"><span class="category">Category:</span> {{item.fullCategoryName}}</div>
          </div>
        </div>
        <div v-if="list.length === 0" style="text-align:center;">No Data</div>
      </div>
      <div style="text-align:right;margin-top:10px" class="bg-white">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[20, 50, 100, 200]"
          :total="total"
          :current-page.sync="filters.pageNumber"
          :page-size="filters.pageSize"
          @current-change="pageCurrentChange"
          @size-change="pageSizeChange"/>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
export default {
  data() {
    return {
      filters: {
        // searchContent: '',
        pageSize: 20,
        pageNumber: 1
      },
      list: [],
      options: [],
      categoryIds: [],
      total: 0,
      colorList: []
    }
  },
  created() {
    this.getButtonCategoriesTree()
    this.getButtons()
  },
  methods: {
    getButtons() {
      let params = _.cloneDeep(this.filters)
      if (params.searchContent && params.searchContent.includes(',')) {
        params.searchContents = params.searchContent.split(',')
        params.searchContent = undefined
      }
      API.getButtons(params).then(res => {
        if (res.code !== 10000) {
          return this.$message.warning(res.message)
        }
        this.list = res.data.list
        this.total = res.data.total
      })
    },
    getButtonCategoriesTree() {
      API.getButtonCategoriesTree({ parentId: 0 }).then(res => {
        this.options = res.data.list.map(item => {
          return {
            label: item.languageList[0].name,
            cn: item.languageList[1].name,
            value: item.categoryId,
            children: item.children ? item.children.map(t => ({ label: t.languageList[0].name, cn: t.languageList[1].name, value: t.categoryId })) : undefined
          }
        })
      })
    },
    changeCascader(arr) {
      let categoryIds = []
      arr.forEach(t => {
        categoryIds.push(t[t.length - 1])
      })
      this.filters.categoryIds = categoryIds
      this.pageCurrentChange(1)
    },
    pageSizeChange(pageSize) {
      this.filters.pageSize = pageSize
      this.getButtons()
    },
    pageCurrentChange(page) {
      this.filters.pageNumber = page
      this.getButtons()
    },
    handleSearchInput() {
      this.pageCurrentChange(1)
    },
    jump(url) {
      // 跳转到 nuxt商城 界面中
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1400px;
  min-width: 1000px;
  margin: 0 auto;
  padding: 15px;
  padding-bottom: 4px;
  .title {
    color: #000;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 15px;
  }
}
.fabric-library-content {
  background-color: #fff;
  padding: 16px 10px 10px 16px;
  .filters {
    margin-bottom: 10px;
    flex-wrap: wrap;
    >div {
      margin-right: 10px;
      margin-bottom: 6px;
    }
    /deep/ .el-input__inner {
      border-radius: unset;
    }
    /deep/ .el-cascader__tags .el-tag {
      max-width: 110px !important;
    }
  }

  .fabric-library-box {
    height: calc(100vh - 220px);
    padding-right: 10px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 6px;
    }
  }
  .fabric-library-list {
    flex-wrap: wrap;
    .fabric-item {
      width: calc((100% - 40px) / 5);
      height: 100%;
      margin-right: 10px;
      padding-bottom: 16px;
      .img {
        width: 100%;
        aspect-ratio: 1 / 1;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      &:nth-child(5n) {
        margin-right: 0;
      }
      .name {
        font-size: 15px;
        margin: 6px 0;
      }
      .category {
        font-size: 13px;
        color: #606266;
        margin-bottom: 3px;
      }
    }
  }
}
</style>
